import { HorizontalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ComponentRow: FunctionComponent<Props> = ({
    className = '',
    label,
    status,
    testId = TEST_ID,
    value
}) => (
    <HorizontalContainer className={`${styles.componentRow} ${className}`} testId={testId}>
        <Wrapper className={styles.componentLabel}>{label}</Wrapper>

        <Wrapper>{value}</Wrapper>

        <Wrapper className={styles.componentValue}>{status}</Wrapper>
    </HorizontalContainer>
);

export default ComponentRow;
